export const alertDialogConstants = {
    title: '일정 시간이 지나 로그아웃 되었습니다.',
    content: '보안을 위해 일정 시간이 지나면, 로그인 기록이 만료되고',
    subContent: '자동 로그아웃이 됩니다. 다시 로그인하여 서비스를 이용해주세요.',
};

export const alertPermissionConstants = {
    alert: '권한이 변경되어 재로그인이 필요합니다.',
};
